import { AutocompleteOption } from '../types/autocomplete'
import {
  User,
  isUserWithContactInfo,
  UserInterface,
  EmailConfirmationResult
} from '../types/users'

const getUserAutocompleteOptions = (users: User[]): AutocompleteOption[] => {
  const usersWithContactInfo = users.filter((user) =>
    isUserWithContactInfo(user)
  ) as UserInterface[]
  const userAutoCompleteOptions: AutocompleteOption[] = usersWithContactInfo.map(
    (user) => ({
      label: `${user.data?.name} - ${user.loginEmail} - ${user.data?.phoneNumber}`,
      value: user.userId
    })
  )
  return userAutoCompleteOptions
}

const getEmailConfirmationResult = (
  emailConfirmationResult: string | undefined
): EmailConfirmationResult => {
  switch (emailConfirmationResult) {
    case 'success':
      return { situation: 'success', messageCode: 'success' }
    case 'undefined':
      return { situation: 'maybeSuccess', messageCode: 'maybeSuccess' }
    case 'CodeMismatchException':
      return { situation: 'error', messageCode: 'CodeMismatchException' }
    case 'ExpiredCodeException':
      return { situation: 'error', messageCode: 'ExpiredCodeException' }
    default:
      return { situation: 'error', messageCode: 'generalError' }
  }
}

export { getUserAutocompleteOptions, getEmailConfirmationResult }
